// import VoraMallLogo from "../../../assets/voramall.png";
import {FRONT_END_TYPE} from "../../../constants.ts";
import { useTranslation } from "react-i18next";


interface ContentProps {
    type: string,
    handleClick: (val: boolean) => void
}

export default function UserInfoVoramall({type, handleClick}: ContentProps) {
    const { t } = useTranslation("ui");

    return type == FRONT_END_TYPE.XSLAB
        ? (
            <>
                <div className="d-block text-center pt-3">
                    <button className="button_blue px-5 py-1" onClick={()=> handleClick(true)}>{t("extension.extendPeriod")}</button>
                </div>
                {/*<div className="mt-5 text-center">*/}
                {/*    <p style={{color: "#9c9b9b"}}>blueshift 서비스 특성상 중도 해지 및 환불이 어렵습니다. 서비스를 이용하지 않은 경우 결제일 이후*/}
                {/*        7일 이내에 보라몰*/}
                {/*        상담문의에 문의사항을 남겨주시면 처리를 도와드리겠습니다.</p>*/}
                {/*    <img src={VoraMallLogo} alt="보라몰"/>*/}
                {/*</div>*/}

            </>
        )
        : (
            <></>
        );
}